// 30ms apart, 180ms each, capped at 8 steps, matching `.focus-page`; Vue needs the total.
const FOCUS_PAGES_STAGGER_STEPS = 8
const FOCUS_PAGES_ENTER_MS = 180 + 30 * FOCUS_PAGES_STAGGER_STEPS
// The pages fold away as one, matching `.focus-pages-leave-active`.
const FOCUS_PAGES_LEAVE_MS = 150

export { FOCUS_PAGES_ENTER_MS, FOCUS_PAGES_LEAVE_MS, FOCUS_PAGES_STAGGER_STEPS }
